export const SORT_OPTIONS = Object.freeze({
  CREATION_DATE: 'CREATION_DATE',
  PLANNED_ACHIEVEMENT: 'PLANNED_ACHIEVEMENT',
  SIGNATURE_ORDER: 'SIGNATURE_ORDER',
  NAME: 'NAME',
})
